var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found-page"},[_c('van-nav-bar',{attrs:{"title":"404 Not found"}}),_c('van-empty',{attrs:{"image":"error","description":"抱歉，找不到您要访问的页面"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }